
import Hero from '../Hero.jsx'
import Highlight from 'components/ckan/Highlight.jsx'
import ValuePropositions from 'components/ckan/ValuePropositions.jsx'
import Features from 'components/ckan/Features.jsx'
import Contact from 'components/ckan/Contact.jsx'
import Contact2 from 'components/ckan/Contact2.jsx'
import Faq from 'components/ckan/training/Faq.jsx'
import CaseStudiesSection from '../CaseStudiesSection';

export default function Index({ casestudies }) { 
  const featured = [
  {
    title: "Open Data Workshops",
    text: "Geared towards providing participants with a comprehensive understanding of Open Data principles and practices.",
    icon: "/assets/icons/presentation-2.json",
  },
    {
    title: "CKAN Workshops for Developers",
    text: "Learn how to setup local CKAN development environment, develop CKAN extensions, plugins, and custom APIs, delve into harvesting, CKAN architecture, best practices, and more.",
    icon: "/assets/icons/html.json",
  },
  {
    title: "CKAN Workshops for Designers",
    text: "Learn how to manage and analyze data, create visualizations, etc.",
    icon: "/assets/icons/presentation-1.json",
  },
  {
    title: "CKAN Workshops for DevOps Engineers",
    text: "Learn how to work with CKAN APIs, develop CKAN extensions, and create custom CKAN plugins using Python and/or JavaScript.",
    icon: "/assets/icons/server.json",
  },
  {
    title: "CKAN Workshops for Business Analysts, Data Analysts, and others",
    text: "Delve into CKAN's core features, including metadata management, API integration with BI tools (e.g. Power BI, Tableau, Qlik Sense etc), custom dashboard creation, harvesting for efficient data analysis and visualization.",
    icon: "/assets/icons/seminar.json",
  },
] 

const values= [
  {
    title: "Customized programs",
    text: "Tailored training to meet your team's unique needs.",
  },
    {
    title: "Flexible schedules",
    text: "Convenient training options to fit your team's busy schedule.",
  },
    {
    title: "Experienced trainers",
    text: "Learn from CKAN experts with real-world experience",
  },
      {
    title: "Real-world examples",
    text: "Learn how to apply CKAN to your projects with practical examples.",
  },
        {
    title: "Certification programs",
    text: "Gain recognition for your CKAN skills and expertise.",
  },
          {
    title: "Ongoing support",
    text: "Choose a plan that works for your specific needs and budget, and upgrade or downgrade as necessary.",
  },
]

const numbers = [
  {
    number: "1000+",
    title: "Projects completed",
  },
    {
    number: "15M+",
    title: "Datasets",
  },
    {
    number: "$5m+",
    title: "APR",
  },
    {
    number: "99.99%",
    title: "Guaranteed uptime",
  },
]
  return (
    <div className="flex flex-wrap justify-center">
      <div className="max-w-7xl w-full">
        <Hero 
        topTitle="CKAN Training"
        title="Get expert training from the team that knows it best."
        subtitle="From beginners to advanced users, we provide comprehensive CKAN training to fit your team's skill levels and needs."
        ctaOffer="See other CKAN services"
        ctaUrl="/ckan#services"/>
         <Highlight subtitle="HOW WE CAN HELP" topTitle="Professional training, courses and workshops" text="Datopian provides professional training, courses and workshops around CKAN including software development, DevOps, design, open data initiatives, open data publishing and licensing, using data as a data analyst and/or scientist, and more."/>
        <Highlight subtitle="WHY CHOOSE US" topTitle="As the creators of CKAN, we have extensive experience and know-how that we can share with you" text="Our team leverages experience gained over a decade of building open data solutions for governments around the world – UK, USA, UAE, Canada, Brazil, Switzerland, Denmark, Germany, Singapore and many other countries. " reverse />
        <Highlight subtitle="WHAT IS CKAN" topTitle="High-impact, interactive learning material" text="The material is specially designed to meet specific learning outcomes, our training workshops also encourage in-depth discussion of the learning topics and thus maximize learner engagement."/>
        <ValuePropositions topTitle="Flexibility to fit your way" title="Don't settle for one-size-fits-all training programs. We offer flexible training schedules and tailored programs to fit your specific needs and skill sets." valuePropositions={values}/>
      </div>
      <Features topTitle="CKAN training for all skill levels" title="From beginners to advanced users, we provide comprehensive CKAN training to fit your team's skill levels and needs." featuredItems={featured} />
      <CaseStudiesSection blogs={casestudies} subtitle="CKAN CONSULTANCY" catalog="ckan" />
      <div className="max-w-7xl w-full">
        <Faq />
      </div>
        <Contact />
        <div className="md:hidden">
          <Contact2 />
        </div>
    </div>
  )
}
